import { render, staticRenderFns } from "./wdlink.vue?vue&type=template&id=6ae8e221&scoped=true"
import script from "./wdlink.vue?vue&type=script&lang=js"
export * from "./wdlink.vue?vue&type=script&lang=js"
import style0 from "./wdlink.vue?vue&type=style&index=0&id=6ae8e221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae8e221",
  null
  
)

export default component.exports